import { CompOnlyType } from "../../types";

// Contains coverage fields that we are interested in
type Coverage = {
  Type: number;
};

const EXCESS_TPL_COVERAGE = 5023;

/**
 * Determines the type of comp only policy for displaying the correct message to the user
 * when trying to access id cards
 * @param hasIdCard Policy.HasIdCard
 * @param policyCoverages Policy.PolicyCoverages
 * @returns CompOnlyType or undefined if not comp only
 */
export function getCompOnlyType(
  hasIdCard: boolean,
  policyCoverages: Coverage[]
): CompOnlyType | undefined {
  // If there is no id card then it is comp only
  if (!hasIdCard) {
    // See https://dev.azure.com/hagerty/Hagerty/_workitems/edit/248350
    return policyCoverages.some((pc) => pc.Type === EXCESS_TPL_COVERAGE)
      ? "EXCESS_TPL"
      : "STANDARD";
  }

  return undefined;
}
